import { HomePage } from '@repo/ccc-main-app-lib/src/pages/HomePage.tsx'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_authenticated/user/$userId/')({
  component: UserMainComponent,
})

function UserMainComponent() {
  const { userId } = Route.useParams()

  return <HomePage userId={userId} />
}
